import { render, staticRenderFns } from "./InstrumentEdit.vue?vue&type=template&id=bb046094"
import script from "./InstrumentEdit.vue?vue&type=script&lang=js"
export * from "./InstrumentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports